// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.headers {\r\n    font-size: 10px !important\n}\n.status {\r\n  color: red;\r\n  margin-left: -13px;\n}\n.recommend-red {\r\n  background-color: red;\n}\n.recommend-orange {\r\n  color: orange;\n}\n.recommend-green {\r\n  color: green\n}\r\n", ""]);
// Exports
module.exports = exports;
